import { FrameTimerPool } from "../Utils/FrameTimerPool";
import { TweenMax } from "gsap";

export class PageVisibilityHandler {
    public static Enabled: boolean = true;

    private static Timer: number;

    public static handle(): void {
        let hidden: string;
        let visibilityChange: string;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        } else {
            return;
        }

        document.addEventListener(
            visibilityChange,
            (e: any) => {
                if (PageVisibilityHandler.Enabled) {
                    let isIos = /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);

                    if (document[hidden]) {
                        PageVisibilityHandler.pauseAll();
                    } else {
                        if (isIos) {
                            clearTimeout(PageVisibilityHandler.Timer);
                            PageVisibilityHandler.Timer = setTimeout(() => {
                                PageVisibilityHandler.resumeAll();
                            }, 200);
                        } else {
                            PageVisibilityHandler.resumeAll();
                        }
                    }
                }
            },
            false,
        );
    }

    public static pauseAll(): void {
        TweenMax.pauseAll();
        FrameTimerPool.pause();
        PIXI.sound.pauseAll();
    }

    public static resumeAll(): void {
        TweenMax.resumeAll();
        FrameTimerPool.unpause();
        PIXI.sound.resumeAll();
        PIXI.sound.unmuteAll();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PageVisibilityHandler.ts
 **/